import { makeStyles } from 'tss-react/mui';

const name = 'AddNetworkButton';

export const useAddNetworkButtonStyles = makeStyles({ name })(theme => ({
  placeholder: {
    width: 38,

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  button: {
    width: 38,
    minWidth: 38,

    '&&': {
      boxShadow: 'none',

      border: `2px solid ${theme.palette.background.default}`,
    },

    '&:hover': {
      backgroundColor: theme.palette.background.default,
    },

    '&:disabled': {
      opacity: 0.4,
    },
  },
  icon: {},
}));
